import {
  TieupSearchGetInputModel,
  TieupSearchGetParams,
} from "src/api/v1/tieup/search/GetInputModel"
import { getTieupSearch } from "src/api/v1/tieup/search/get"
import { Paging } from "../../paging/paging"
import { WorkItem } from "../../WorkItem/WorkItem"

export const fetchTieupSearch = (
  params: TieupSearchGetParams,
): Promise<Paging<WorkItem>> => {
  const model = new TieupSearchGetInputModel(params)

  return getTieupSearch(model).then((res) => {
    return {
      total: res.count,
      items: res.results,
    }
  })
}
